/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlan/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Appointment from './Appointment/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useListItemDataOnSubmit from './useListItemDataOnSubmit.js'



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlan({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan"
  
}) {
let treatmentPlansValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_plans',
format: fromHelpers.getWidth,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let treatmentPlanNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: 'name',
})
let treatmentPlanAppointmentsValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_plan',
path: 'appointments',
format: fromHelpers.getSubtitle,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let treatmentPlanAppointmentsValueData1 = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: 'appointments',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<div
  data-testid="TreatmentPlan.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-2-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-3-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-b2MGG': dtColorsNeutral200,'--w-6-b2MGG': typeof treatmentPlansValueData === 'number' ? `${treatmentPlansValueData}px` : treatmentPlansValueData}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TreatmentPlan.Horizontal"
  data-view-path={viewPath}
 style={{'--bbc-7-b2MGG': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TreatmentPlan.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-8-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-b2MGG': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-b2MGG': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-11-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 textOverflow="ellipses"
 overflowY="hidden"
 data="treatment_plan.name"
 text={treatmentPlanNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="treatment_plan.appointments"
 format="helpers.js getSubtitle"
 text={treatmentPlanAppointmentsValueData}
/>
</div>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
<div
  data-testid="TreatmentPlan.List"
  data-view-path={viewPath}
 style={{'--pt-8-b2MGG': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-11-b2MGG': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-9-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-10-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-12-b2MGG': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-13-b2MGG': dtColorsNeutral100}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(treatmentPlanAppointmentsValueData1) && treatmentPlanAppointmentsValueData1.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="appointment"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Appointment(${item?.id ?? item?._id ?? index})`}
      >
<Appointment
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Appointment(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    let onSubmit = useListItemDataOnSubmit(props)
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      onSubmit={onSubmit}
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }